import type { ReactNode } from "react";
import { TemplateFieldValidationContext } from "./TemplateFieldValidationContext";

export const TemplateFieldValidationContextProvider = ({
  children,
  value,
}: {
  children: ReactNode;
  value: {
    isInFinalValidationPhase: boolean;
  };
}) => {
  return (
    <TemplateFieldValidationContext.Provider
      value={value.isInFinalValidationPhase}
    >
      {children}
    </TemplateFieldValidationContext.Provider>
  );
};
